import { configureStore, DeepPartial, getDefaultMiddleware, Middleware } from '@reduxjs/toolkit';
import logger from 'redux-logger';
import {
    FLUSH,
    PAUSE,
    PERSIST,
    persistReducer,
    persistStore,
    PURGE,
    REGISTER,
    REHYDRATE,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import rootReducer from '€slices/index';
import packageJson from '~/package.json';
import { RootState } from '€slices/types';

const defaultMiddleware = getDefaultMiddleware({
    serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
    },
});

const isBrowser = typeof window !== 'undefined';

if (
    process.env.NODE_ENV === 'development' &&
    isBrowser &&
    process.env.NEXT_PUBLIC_NO_REDUX_LOGGER !== 'true'
) {
    defaultMiddleware.push(logger);
}

const persistConfig = {
    key: `root-${packageJson.version}`,
    storage,
    blacklist: ['passwordReset', 'signUp', 'auth', 'network', 'chat', 'formEntry', 'quickQuote'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const createStoreWithMiddleware = (
    preloadedState?: DeepPartial<RootState>,
    middleware: Middleware[] = defaultMiddleware,
) => {
    const store = configureStore({
        reducer: persistedReducer,
        // preloadedState,
        middleware,
    });

    const persistor = persistStore(store);

    return { store, persistor };
};

export const { store, persistor } = createStoreWithMiddleware();
